module.exports = "<div class=\"card-item\">\n    <input class=\"task\" type=\"text\">\n</div>"